import { CSSProperties } from 'react';
import Carousel from 'react-material-ui-carousel'
import { useIsMobileView } from '../../utils/responsive';
import { Box, CardMedia } from '@mui/material';
import { getPrimaryColorByAccountId, getThemeByAccountId, styleConstants } from '../../utils/styleConstants';
import { useAppSelector } from '../../store/hooks/useAppSelector';
import { RootState } from '../../store/types/rootState';

interface PreviewRaffleImagesProps {
    images: any[]
}

export function PreviewRaffleImages({ images }: PreviewRaffleImagesProps)
{

    const accountId = useAppSelector(
        ({ account }: RootState) => account.id,
      );

    const isMobile = useIsMobileView();

    const sx: CSSProperties = {
        width: isMobile ? '100%': '100%',
        height: isMobile ? '566px': '100%',
        display: 'flex',
        boxShadow: "inset 0px 0px 20px rgba(0,0,0,0.5) !important", // <-- inset shadow
// -webkit-box-shadow: 0px -54px 20px -8px rgba(0,0,0,0.75) inset;
// -moz-box-shadow: 0px -54px 20px -8px rgba(0,0,0,0.75) inset;
    }
    return (
        <Box>
        <Carousel indicators={false} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {images.map((image, imgIndex) => (
                <Box
                sx={{
                    overflow: "hidden",
                    position: "relative",
                }}
                >
                    <CardMedia
                    key={imgIndex}
                    component="img"
                    style={sx}
                    src={URL.createObjectURL(image)}
                    />
                <Box
                    sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    boxShadow: `inset 0 -90px 60px 0px ${getThemeByAccountId(accountId) === 'light' ? '#fff' : 'rgba(0,0,0,1)'}`,
                    pointerEvents: "none", // Important: let clicks pass through!
                    }}
                />
                </Box>
            ))}
        </Carousel>
        </Box>
    )
}
